module.exports = __webpack_public_path__ + "static/devculture-a6cd7e085bc11ff8e9d42824849aebfe.jpeg";